export default __webpack_public_path__ + "static/media/hands.fa0e2d18.jpg";